import styled from 'styled-components'
import {Button} from './button.styled'

export const LargerButton = styled(Button)`
    width: 45px;
`
